const Footer = () => {
	return (
		<footer className="py-4 px-4 flex flex-col items-center bg-surface border-t border-white/20 mt-auto">
			<p className="font-medium text-center text-sm text-text-muted">
				Made with <span className="text-secondary">&hearts;</span> By IT Solutions Bureau
			</p>
		</footer>
	);
}

export default Footer;
